import React from "react";
import { Title } from "../../components/Title";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const CognitoIntro = () => {
  const { t } = useTranslation();
  return (
    <div className="build-idaas-service">
      <section>
        <div className="inner">
          <Title title={t("solution.cognito.intro.title")}></Title>
          <div className="intro-warp">
            <div className="descript-warp">
              <div className="item">
                <span className="text">{t("solution.cognito.intro.descript1")}</span>
              </div>
              <div className="item">
                <span className="text">{t("solution.cognito.intro.descript2")}</span>
              </div>
            </div>
            <div className="intro-img">
              <img
                src="//files.authing.co/authing-website/cognito-logo-aws.png"
                alt="authing cognito aws"
                width="140"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
